<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <div class="card-content">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Firstname</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="firstname"
                  class="w-full"
                  v-model="form.speaker_firstname"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('firstname')"
                  >{{ errors.first("firstname") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Lastname</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="lastname"
                  class="w-full"
                  v-model="form.speaker_lastname"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('lastname')"
                  >{{ errors.first("lastname") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Tag Line</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="tagline"
                  class="w-full"
                  v-model="form.speaker_tagline"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('tagline')"
                  >{{ errors.first("tagline") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  rows="5"
                  v-validate="''"
                  name="shortdesc"
                  class="w-full"
                  v-model="form.speaker_shortdesc"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('shortdesc')"
                  >{{ errors.first("shortdesc") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Long Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  rows="5"
                  name="longdesc"
                  class="w-full"
                  v-model="form.speaker_longdesc"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('longdesc')"
                  >{{ errors.first("longdesc") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Profile Image</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="file"
                  ref="profile_img"
                  name="profile_img"
                  class="w-full"
                  v-model="form.profile_img"
                  @change="setProfileImg"
                />
                Dimension must be 500x500px and file size must not be more than
                1MB
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('profile_img')"
                  >{{ errors.first("profile_img") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Phone</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="phone"
                  class="w-full"
                  v-model="form.speaker_phone"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('phone')"
                  >{{ errors.first("phone") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Email</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="email"
                  class="w-full"
                  v-model="form.speaker_email"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('email')"
                  >{{ errors.first("email") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Website (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="website"
                  class="w-full"
                  v-model="form.speaker_website"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('website')"
                  >{{ errors.first("website") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Facebook (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="facebook"
                  class="w-full"
                  v-model="form.speaker_facebook"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('facebook')"
                  >{{ errors.first("facebook") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Twitter (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="twitter"
                  class="w-full"
                  v-model="form.speaker_twitter"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('twitter')"
                  >{{ errors.first("twitter") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Linkedin (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="linkedin"
                  class="w-full"
                  v-model="form.speaker_linkedin"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('linkedin')"
                  >{{ errors.first("linkedin") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Youtube (optional)</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="youtube"
                  class="w-full"
                  v-model="form.speaker_youtube"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('youtube')"
                  >{{ errors.first("youtube") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Weight</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input name="weight" class="w-full" v-model="form.weight" />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('weight')"
                  >{{ errors.first("weight") }}</span
                >
              </div>
            </div>
          </div>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Create</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";
import { timezones } from "@/utils/Timezones";
import { currencyList } from "@/utils/Constants";

const dict = {
  form: {
    name: {
      required: "Please enter an event name"
    },
    slug: {
      required: "Please enter your last name",
      alpha: "Your last name may only contain alphabetic characters"
    }
  }
};

// register custom messages
Validator.localize("en", dict);
export default {
  components: {},
  data: () => ({
    suffixParams: "",
    timezones: timezones,
    valid: true,
    file: {
      speaker_profile_img: null
    },
    form: {
      slug: null,
      speaker_displayname: null,
      speaker_firstname: null,
      speaker_lastname: null,
      speaker_tagline: null,
      speaker_shortdesc: null,
      speaker_longdesc: null,
      speaker_profile_img: null,
      speaker_phone: null,
      speaker_email: null,
      speaker_website: null,
      speaker_address: null,
      speaker_city: null,
      speaker_country: null,
      speaker_facebook: null,
      speaker_twitter: null,
      speaker_linkedin: null,
      speaker_youtube: null,
      speaker_line: null,
      speaker_instagram: null,
      speaker_soundcloud: null,
      speaker_spotify: null,
      speaker_industry: null,
      speaker_main: null,
      speaker_featured_img: null,
      publish_status: true,
      listing_status: true,
      weight: 0,
      speaker_remark: null,
      speaker_filter: null
    }
  }),
  created() {
    setTimeout(() => {
      this.suffixParams =
        "?s=" + this.$route.query.s + "&e=" + this.$route.query.e;
    }, 1000);
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s
      };

      this.form.slug = this.slug(
        this.form.speaker_firstname +
          " " +
          this.form.speaker_lastname +
          " " +
          this.generateNumber()
      );

      this.form.speaker_displayname =
        this.form.speaker_firstname + " " + this.form.speaker_lastname;

      this.form = { ...this.form, ...data };

      this.$vs.loading();
      Service.Speaker.create(this.form)
        .then(res => {
          if (res.success) {
            this.doUploadFile(res.data.speaker.speaker_id);

            this.$vs.notify({
              title: "Success",
              text: "Add Speaker Complete.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    doUploadFile(speaker_id) {
      var formData = new FormData();

      formData.append("e", this.$route.query.e);

      if (this.file.speaker_profile_img != null) {
        formData.append("speaker_profile_img", this.file.speaker_profile_img);
      }

      Service.Speaker.upload(speaker_id, formData).then(res => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Add Speaker Complete.",
            color: "success"
          });
          this.$router.push("/conferences/speakers" + this.suffixParams);
        }
      });
    },
    setProfileImg(e) {
      this.file.speaker_profile_img = e.target.files[0];
    },
    slug(word) {
      let resp = word
        .toLowerCase() // LowerCase
        .replace(/\s+/g, "-") // space to -
        .replace(/&/g, `-and-`) // & to and
        .replace(/--/g, `-`); // -- to -
      return resp;
    },
    generateNumber: function() {
      return Math.floor(Math.random() * (99999999 - 10000000 + 1) + 10000000);
    }
  }
};
</script>
